import { render, staticRenderFns } from "./homeWaterPurifierMng.vue?vue&type=template&id=4ecfadfe&scoped=true"
import script from "./homeWaterPurifierMng.vue?vue&type=script&lang=js"
export * from "./homeWaterPurifierMng.vue?vue&type=script&lang=js"
import style0 from "./homeWaterPurifierMng.vue?vue&type=style&index=0&id=4ecfadfe&prod&lang=css"
import style1 from "./homeWaterPurifierMng.vue?vue&type=style&index=1&id=4ecfadfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfadfe",
  null
  
)

export default component.exports